<div class="d-flex flex-column h-100">
    <ag-grid-angular 
        #webhelpEtsGrid
        class="ag-theme-balham flex-fill"
        *ngIf="gridOptions"
        [gridOptions]="gridOptions">
    </ag-grid-angular>
</div>